export const CONTENT_CONFIG = Object.freeze({
    page: Object.freeze({
        label: 'Page',
        collectionLabel: 'Pages',
        backLabel: 'Back to pages',
    }),
    blog: Object.freeze({
        label: 'Blog post',
        collectionLabel: 'Blog',
        backLabel: 'Back to blog posts',
    }),
});

export function contentConfig(kind) {
    return CONTENT_CONFIG[kind === 'blog' ? 'blog' : 'page'];
}
